import Component from '@bythepixel/component-loader';

const DEFAULTS = {
  activatorSelector: '[data-comp-accordion-activator]',
  panelSelector: '[data-comp-accordion-panel]',
  contentSelector: '[data-comp-accordion-content]',
  buttonSelector: '[data-comp-accordion-button]',
  toggleClassname: 'hide',
};

export default class Accordion extends Component {
  static selector = '[data-comp-accordion]';

  constructor(containerEl, options = DEFAULTS) {
    super(containerEl, options);
    this.activator = this.$container.querySelector(options.activatorSelector);
    this.panels = [...this.$container.querySelectorAll(options.panelSelector)];
    this.content = this.$container.querySelector(options.contentSelector);
    this.button = this.$container.querySelector(options.buttonSelector);
    this.mount();
  }

  mount() {
    this.panels.forEach((panel) => {
      const activator = panel.querySelector(this.$options.activatorSelector);
      const content = panel.querySelector(this.$options.contentSelector);
      const button = panel.querySelector(this.$options.buttonSelector);

      const handleAccordion = () => {
        if (button) {
          button.classList.toggle('activated');
        }
        if (content) {
          const isExpanded = activator.getAttribute('aria-expanded') === 'true';
          activator.setAttribute('aria-expanded', !isExpanded);
          content.setAttribute('aria-hidden', isExpanded);
          content.classList.toggle(this.$options.toggleClassname);
        }
      };

      activator.addEventListener('click', () => {
        handleAccordion();
      });

      activator.addEventListener('keydown', (e) => {
        if (e.code === 'Enter' || e.code === 'Space') {
          e.preventDefault();
          handleAccordion();
        }
      });
    });
  }
}
